// extracted by mini-css-extract-plugin
export default {"linkIcon":"style_linkIcon__JEb4e"};